import React from 'react';
import styles from './RegisterForm.module.css';

const RoleSelector = ({ check, setCheck }) => {
    return (
        <fieldset className={styles.checkBox}>
            <legend className={styles.title}>Vous souhaitez créer un compte:</legend>

            <div className={styles.options}>
                <input
                    type="checkbox"
                    id="client"
                    checked={check}
                    onChange={() => setCheck(true)}
                />
                <label htmlFor="client">Client</label>
            </div>

            <div className={styles.options}>
                <input
                    type="checkbox"
                    id="trader"
                    checked={!check}
                    onChange={() => setCheck(false)}
                />
                <label htmlFor="trader">Commerçant</label>
            </div>
        </fieldset>
    );
};

export default RoleSelector;
